import { IIModel } from '../../../../model/candidato-api'
import { RestClient } from '../../../data/rest-client'

export class Editor<T extends IIModel> {
  filas: T[]

  constructor(private client: RestClient<T>) {}

  refresh() {
    return this.client.findAll().then((listado) => (this.filas = listado))
  }

  guardar(item: T) {
    return this.client.save(item).then(() => this.refresh())
  }

  nuevo(item: T) {
    return this.client.add(item).then(() => this.refresh())
  }
}
